import Region from '@/creditflowresearch/domain/Region';
import { TruncatedTextCell } from '@/creditflowresearch/ui/common/components/DataCells';

interface IRegionsCellProps {
  regionIds: string[] | null | undefined,
}

const RegionsCell = ({ regionIds }: IRegionsCellProps) => {
  if (!regionIds || regionIds.length === 0) {
    return (<>-</>);
  }

  const regions = regionIds
    .map((id) => Region.from(id))
    .filter(Boolean);

  if (regions.length === 0) {
    return (<>-</>);
  }

  const display = regions.map((r) => r!.getAbbreviation()).join(', ');
  const tooltip = regions.map((r) => r!.getName()).join(', ');

  return (<TruncatedTextCell value={ display } tooltip={ tooltip } />);
};

export default RegionsCell;
